import { ShieldCheck } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export function AccessDenied({ module }) {
  const navigate = useNavigate();
  return (
    <div className="page-enter p-6 sm:p-8 flex flex-col items-center justify-center min-h-[50vh]" data-testid="access-denied">
      <div className="w-16 h-16 bg-[#FEF2F2] flex items-center justify-center mb-4">
        <ShieldCheck size={32} className="text-[#DC2626]" weight="duotone" />
      </div>
      <h2 className="text-xl font-black text-[#0A0A0A] tracking-tight mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Access Denied</h2>
      <p className="text-sm text-[#525252] text-center max-w-sm mb-6">
        You do not have permission to access {module ? <strong>{module}</strong> : "this section"}. Contact your administrator to request access.
      </p>
      <button
        onClick={() => navigate("/dashboard")}
        className="px-6 py-2 bg-[#0055FF] text-white text-sm font-bold uppercase tracking-wider hover:bg-[#003ECB] transition-colors"
        data-testid="access-denied-back"
      >
        Back to Dashboard
      </button>
    </div>
  );
}
